import { useQuery } from '@tanstack/react-query';

import { usePublicAssetTenant } from '../providers/PublicAssetTenantProvider/PublicAssetTenantProvider';
import BackendService from '../services/backendService';
import { LessonAttachment } from '../services/backendService/backendService';

export const useAttachmentContent = (
  attachment: LessonAttachment,
  isFromDiscover: boolean,
) => {
  const tenantId = usePublicAssetTenant();
  const { data } = useQuery({
    queryKey: ['attachment', attachment.attachmentId, attachment.modifiedAt, tenantId],

    queryFn: async () => {
      return BackendService.instance.gameFiles.fetchAttachmentContent({
        fileId: attachment.fileId,
        isFromDiscover: isFromDiscover,
        tenantId,
      });
    },

    staleTime: 1000 * 60 * 60 * 24,
  });

  return { content: data };
};
